import * as React from "react";
import { styled } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const BpIcon = styled("span")(({ theme }) => ({
  border: "0px solid transparent",
  borderRadius: "50%",
  width: 16,
  height: 16,
  backgroundColor: "#D9D9D9",
  "input:hover ~ &": {
    backgroundColor: "#A9A9A9",
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#000000",

  "&::before": {
    display: "block",
    width: 16,
    height: 16,
  },
  "input:hover ~ &": {
    backgroundColor: "#000000",
  },
});

function BpRadio(props) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

export default function CustomizedRadios({ radioTexts = ["", "", ""] }) {
  return (
    <FormControl>
      <FormLabel
        id="demo-customized-radios"
        sx={{
          fontSize: "16px",
          fontWeight: "600",
          lineHeight: "19.36px",
          color: "#000000",
          "&.Mui-focused": {
            color: "#000000", // Prevent blue color when focused
          },
          pb: "10px",
        }}
      >
        Connection Request
      </FormLabel>
      <RadioGroup
        defaultValue="female"
        aria-labelledby="demo-customized-radios"
        name="customized-radios"
        sx={{ pl: "4px" }}
      >
        <FormControlLabel
          value="female"
          sx={{ fontSize: "16px", fontWeight: "400", lineHeight: "19.36px" }}
          control={<BpRadio />}
          label="Everyone on social (recommended)"
        />

        <FormControlLabel
          sx={{ fontSize: "16px", fontWeight: "400", lineHeight: "19.36px" }}
          value="male"
          control={<BpRadio />}
          label="Only people who know your email address"
        />
        <FormControlLabel
          sx={{ fontSize: "16px", fontWeight: "400", lineHeight: "19.36px" }}
          value="other"
          control={<BpRadio />}
          label="Only people who appear in your mutual connection list"
        />
      </RadioGroup>
    </FormControl>
  );
}
